import { render, staticRenderFns } from "./MarkLoader.vue?vue&type=template&id=07ec271c&scoped=true"
import script from "./MarkLoader.vue?vue&type=script&lang=ts"
export * from "./MarkLoader.vue?vue&type=script&lang=ts"
import style0 from "./MarkLoader.vue?vue&type=style&index=0&id=07ec271c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ec271c",
  null
  
)

export default component.exports